export default "__VITE_ASSET__43628bd4__"